<template>
  <div class="container-fluid bg-light pt-5 pb-5">
    <h4>ON SALE</h4>

    <div class="underline-green"></div>
    <div class="foxes mt-5">
      <SalesCard
        v-for="product in products"
        :key="product.id"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import SalesCard from "./SalesCard";
export default {
  name: "Sales",
  components: {
    SalesCard
  },
  computed: {
    products() {
      let product = this.$store.state.allProducts;
      let shuffleProduct = this.shuffleArray(product);
      let newProduct = shuffleProduct.slice(0, 4);
      return newProduct;
    }
  },
  methods: {
    shuffleArray: function(array) {
      var ctr = array.length,
        temp,
        index;
      while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = array[ctr];
        array[ctr] = array[index];
        array[index] = temp;
      }
      return array;
    }
  }
};
</script>

<style></style>
